export default __webpack_public_path__ + "static/media/showroom31.c5917998.jpg";